import { gql } from "@apollo/client";

export const ssoUserUpdateMutation = gql`
  mutation sso_user_update {
    sso_user_update {
      result {
        success
        errors {
          message
        }
      }
    }
  }
`;
